import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["description", "option", "caption", "options", "value"],
  _excluded2 = ["options"],
  _excluded3 = ["description", "option", "caption", "value", "appearance"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { flattenItems } from '../legacy';
import { isAccordionOptionProps, isGroupOptionProps, isNextListOptionProps } from './typeGuards';
export function transformOptionsToItems(options) {
  return options.map(function (option) {
    if (isAccordionOptionProps(option) || isNextListOptionProps(option)) {
      var _description = option.description,
        _contentOption = option.option,
        _caption = option.caption,
        _options = option.options,
        _value = option.value,
        _rest = _objectWithoutProperties(option, _excluded);
      return _objectSpread(_objectSpread({
        'data-test-id': 'field-select__list-option-' + option.value
      }, _rest), {}, {
        id: _value,
        content: {
          option: _contentOption,
          caption: _caption,
          description: _description
        },
        items: transformOptionsToItems(_options)
      });
    }
    if (isGroupOptionProps(option)) {
      var _options2 = option.options,
        _rest2 = _objectWithoutProperties(option, _excluded2);
      return _objectSpread(_objectSpread({}, _rest2), {}, {
        items: transformOptionsToItems(_options2)
      });
    }
    var _ref = option,
      description = _ref.description,
      contentOption = _ref.option,
      caption = _ref.caption,
      value = _ref.value,
      appearance = _ref.appearance,
      rest = _objectWithoutProperties(_ref, _excluded3);
    return _objectSpread(_objectSpread({
      'data-test-id': 'field-select__list-option-' + option.value
    }, rest), {}, {
      id: value,
      appearance: appearance,
      content: {
        description: description,
        option: contentOption,
        caption: caption
      }
    });
  });
}
export function findSelectedOption(items, value) {
  var flatten = flattenItems(items);
  if (!value) {
    return [undefined, undefined];
  }
  var foundItem = flatten.find(function (item) {
    return String(item.id) === String(value);
  });
  var placeholderItem = {
    id: value,
    content: {
      option: String(value)
    }
  };
  return [foundItem, !foundItem ? placeholderItem : undefined];
}
export function findSelectedOptions(items, value) {
  var flatten = flattenItems(items);
  if (!value || !(value !== null && value !== void 0 && value.length)) {
    return [undefined, undefined];
  }
  var foundItems;
  var placeholderItems;
  value.forEach(function (value) {
    if (flatten) {
      var _findSelectedOption = findSelectedOption(flatten, value),
        _findSelectedOption2 = _slicedToArray(_findSelectedOption, 2),
        found = _findSelectedOption2[0],
        placeholder = _findSelectedOption2[1];
      if (found || foundItems) {
        var _foundItems;
        foundItems = ((_foundItems = foundItems) !== null && _foundItems !== void 0 ? _foundItems : []).concat(found !== null && found !== void 0 ? found : []);
      }
      if (placeholder || placeholderItems) {
        var _placeholderItems;
        placeholderItems = ((_placeholderItems = placeholderItems) !== null && _placeholderItems !== void 0 ? _placeholderItems : []).concat(placeholder !== null && placeholder !== void 0 ? placeholder : []);
      }
    }
  });
  return [foundItems, placeholderItems];
}